<template>
  <div class="setComponent">
    <!-- 表单 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="form-setting" size="medium">
      <el-form-item :label="$i18n.t('wm_lang_d7ec2d')" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_2d711b')">
        <tinymce-editor ref="editor" :editorType="'base64'" v-model="ruleForm.content" style="width:70%;"></tinymce-editor>
      </el-form-item>
      <el-form-item>
        <el-button v-show="!ruleForm.mailAccountDef" type="primary" @click="submitForm('ruleForm')">{{$t("wm_lang_html_be5fbb")}}</el-button>
        <el-button type="primary" @click="submitForm('ruleForm', true)">{{$t("wm_lang_html_552823")}}</el-button>
        <el-button @click="cancelForm">{{$t("wm_lang_html_625fb2")}}</el-button>
      </el-form-item>
    </el-form>
    <br><br>
  </div>
</template>

<script>
import xmail from '@/api/api';
import { isEmail } from '@/utils/validate';
import TinymceEditor from '@/components/views/editor/tinymce-editor'

export default {
  name: 'addSignature',
  data () {
    return {
      ruleForm: {
        name: "",
        content: "",
        mailAccountDef: false,
        signId: ''
      },
      rules: {
        name: [
          { max: 20, message: this.$i18n.t('wm_lang_379b24')+'20'+this.$i18n.t('wm_lang_15d410'), trigger: 'blur' }
        ]
      }
    }
  },
  components:{
    TinymceEditor
  },
  mounted() {
    let signId = this.$route.params.id;
    if(signId) {
      this.getSign(signId);
    }
    else {
      // 新建个人签名时，如果没有修改字号和字体大小，需要带上默认的字号和大小，防止写信页面会全局覆盖
      this.ruleForm.content = `<div style="font-family: '宋体'; font-size: 12px; line-height: 1.6"></div>`;
    }
  },
  methods: {
    getSign(id) {
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Sign.queryMailAccountSignParamBuilder();
        pm.signId = id;
        api.Sign.queryMailAccountSign(pm, function (res) {
          console.log(res.data)
          if(res.data.code === 0) {
            if(Object.keys(res.data.data).length === 0) {
              return;
            }
            self.ruleForm = res.data.data;
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    cancelForm() {
      this.$router.push({name: 'signatureSetting'});
    },
    submitForm(formName, def) {
      if(!this.ruleForm.name) {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_a41baf')
        });
        return;
      }
      if(!this.ruleForm.content) {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('wm_lang_d32b45')
        });
        return;
      }
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          let self = this;
          if(self.ruleForm.signId) {
            (function (api, enums, pms) {
              if(def) {
                self.ruleForm.mailAccountDef = true;
              } else {
                self.ruleForm.mailAccountDef = false;
              }
              let pm = self.ruleForm;
              api.Sign.updateMailAccountSign(pm, function (res) {
                // console.log(res)
                if(res.data.code === 0) {
                  self.$message({
                    type: 'success',
                    message: self.$i18n.t('wm_lang_69be67')
                  });
                  self.$router.push({name: 'signatureSetting'});
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
          } else {
            (function (api, enums, pms) {
              if(def) {
                self.ruleForm.mailAccountDef = true;
              } else {
                self.ruleForm.mailAccountDef = false;
              }
              let pm = self.ruleForm;
              api.Sign.addMailAccountSign(pm, function (res) {
                // console.log(res)
                if(res.data.code === 0) {
                  self.$message({
                    type: 'success',
                    message: self.$i18n.t('wm_lang_3fdaea')
                  });
                  self.$router.push({name: 'signatureSetting'});
                }
              })
            })(xmail.api, xmail.enums, xmail.pms);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/addSignature.vue